<template>
  <ContentfulThreeColumnsList
    v-if="layout === 'list' && hotelItems"
    :title="title"
    :all-title="$t('website.locationcollection.tab.all')"
    :data="hotelItems"
  />

  <HotelMapView v-else-if="layout === 'map'" :title="title" />
  <ContentfulLocationCollectionSlider
    v-else-if="layout === 'slider'"
    :title="title"
    :locations="locations"
    :callToAction="callToAction"
  />

  <DevMessage v-else>
    Unfortunately, LocationCollection with layout "{{ layout }}" is not
    available
  </DevMessage>
</template>

<script setup lang="ts">
import type { TypeLocationCollectionFields } from "@citizenm/contentful/shared/types/marketing/generated";

const { hotelItems } = useNavigationItems();

defineProps<{
  title: string;
  layout: "list" | "map" | "slider";
  // locationType: This property exists in Contentful, but is currently not being used until a decision is made on the concept of this model.
  locations?: Record<string, any>;
  callToAction?: TypeLocationCollectionFields["callToAction"];
}>();
</script>
